import {$api} from "shared/api";

export const archiveHive = async (hiveId: string) => {
    const http = await $api.delete<any>(`/hives/${hiveId}`);
    return http.status
}

export const unarchiveHive = async (hiveId: string) => {
    const http = await $api.patch<any>(`/hives/${hiveId}/restore`);
    return http.status
}